"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
import { useMyLinkProfileQuery } from "@/modules/creator/services/creatorClient";
import { CreatorTopBanner } from "./CreatorTopBanner";

const MINIMUM_KEYWORD_COUNT = 3;

export function CreatorKeywordsBanner() {
  const t = useTranslations("common");
  const { data: creatorProfile } = useMyLinkProfileQuery();
  const hasActiveWarning = Boolean(creatorProfile?.warning?.message);
  const keywordCount = new Set(
    (creatorProfile?.settings?.jobFeedPreferences?.positiveKeywords || [])
      .map((keyword) => keyword.trim().toLowerCase())
      .filter(Boolean),
  ).size;

  if (
    !creatorProfile ||
    hasActiveWarning ||
    keywordCount >= MINIMUM_KEYWORD_COUNT
  ) {
    return null;
  }

  return (
    <CreatorTopBanner tone="requiredAction">
      {t("keywordBannerMessage")} {" "}
      <Link
        href="/my-link?edit=settings"
        className="font-bold text-red-700 underline underline-offset-2"
      >
        {t("keywordBannerAction")}
      </Link>
    </CreatorTopBanner>
  );
}
